import React from 'react';
import { SITE_CONTENT } from '../content';

const AboutUsIntro = () => {
  const intro = SITE_CONTENT.pages?.aboutUsPage?.intro || {};
  const subtitle = intro.subtitle || "Our Story";
  const title = intro.title || "Born in Tamil Nadu";
  const paragraphs = intro.paragraphs || [];
  const quote = intro.quote || { text: "", author: "A NonVeeFoods Brand", image: "" };

  return (
    <section className="bg-[#f0eee5] py-20 lg:py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Eyebrow */}
        <p className="text-[#1a2e1a] text-xs font-bold tracking-[0.25em] uppercase mb-4">
          {subtitle}
        </p>

        {/* Heading */}
        <h2 className="text-[#1a2e1a] text-4xl sm:text-5xl font-semibold mb-8">
          {title}
        </h2>

        {/* Paragraphs */}
        <div className="text-[#7a7a68] space-y-6 mb-12 text-sm sm:text-base leading-relaxed max-w-3xl mx-auto">
          {paragraphs.map((text, idx) => (
            <p key={idx}>{text}</p>
          ))}
        </div>

        {/* Quote Box Container */}
        <div className="max-w-2xl mx-auto border border-gray-300 p-8 sm:p-10 relative text-left flex flex-col sm:flex-row items-center sm:items-start gap-6 bg-transparent">
          {/* Avatar */}
          <div className="w-16 h-16 rounded-full overflow-hidden shrink-0">
            <img 
              src={quote.image} 
              alt={quote.author} 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Quote Content */}
          <div className="flex-1 relative z-10 text-center sm:text-left">
            <p className="text-[#7a7a68] text-sm leading-relaxed mb-6 italic">
              {quote.text}
            </p>
            {/* Signature Placeholder */}
            <div className="text-[#1a2e1a] text-2xl" style={{ fontFamily: "'Brush Script MT', 'Great Vibes', cursive" }}>
              {quote.author}
            </div>
          </div>

          {/* Decorative Quote Mark */}
          <div className="absolute bottom-4 right-6 text-8xl font-serif text-gray-200 opacity-60 select-none z-0">
            ”
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsIntro;
